const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF;

export const HiddenExcelCommand: any = {
    CreateHiddenExcelTable: `${Backofficebff}/v1/hiddenexcel/tables`,
    UpdateHiddenExcelTable: `${Backofficebff}/v1/hiddenexcel/tables`,
    DeleteHiddenExcelTable: `${Backofficebff}/v1/hiddenexcel/tables`,
};
